
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { keyTree, ifExitKey, types, typeKey, setDefault } from "./template";
import EditMark from "./edit-mark.vue";
const TemplateEdit = () => import("./template-edit.vue");
import TemplateRead from "./template-read.vue";
import EditJianyanzu from "./edit-jianyanzu.vue";
import ReadJianyanzu from "./read-jianyanzu.vue";
import EditTable from "./edit-table.vue";
import ReadTable from "./read-table.vue";
@Component({
  components: {
    TemplateEdit,
    TemplateRead,
    EditMark,
    EditJianyanzu,
    ReadJianyanzu,
    EditTable,
    ReadTable,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifErji: any;
  @Watch("ifErji", { immediate: true })
  private ifErjiChange() {
    this.getTypes();
  }
  @Prop()
  private isShow: any;
  @Watch("isShow", { immediate: true })
  private isShowChange() {
    this.ifShowAddWenti = this.isShow;
  }
  @Prop()
  private data: any;
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      this.addData = JSON.parse(JSON.stringify(this.data));
      this.getTypeKeys();
    }
  }
  @Prop()
  private moban: any;
  private ifShowAddWenti: any = false;
  private addData: any = {};
  private optionData: any = {};
  private types: any = [];
  private formats: any = [
    "yyyy-MM-dd HH:mm:ss",
    "yyyy-MM-dd HH:mm",
    "yyyy-MM-dd HH",
    "yyyy-MM-dd",
    "yyyy-MM",
    "yyyy",
  ];
  private ifShowErji: any = false;
  private erjiType: any = ""; // sub_title或extra
  private erjiData: any = {};
  private typekeys: any = [];
  private ifShowMark: any = false;
  private ifShowJianyanxiang: any = false;
  private ifShowTable: any = false;
  private jianyanData: any = [];
  private tableData: any = [];
  private jianyanIndex: any = "";
  private precisions: any = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  private getTypes() {
    let arr: any = [];
    // 二级有些控件不支持嵌套
    if (this.ifErji) {
      types().forEach((ele: any) => {
        if (
          ele != "目录式多选" &&
          ele != "压痛点" &&
          ele != "中药饮片信息" &&
          ele != "其它用药信息" &&
          ele != "动态数组" &&
          ele != "检验组" &&
          ele != "表格"
        ) {
          arr.push(ele);
        }
      });
    } else {
      arr = types();
    }
    this.types = arr;
  }
  private getTypeKeys() {
    let arr: any = [];
    const strArr: any = typeKey(this.addData.type);
    if (strArr && strArr.length > 0) {
      strArr.forEach((ele: any) => {
        // id不能编辑,二级编辑，二级嵌套和逻辑控制不能用
        if (this.ifErji) {
          if (
            ele != "id" &&
            ele != "extra" &&
            ele != "hide" &&
            ele != "control" &&
            ele != "basic"
          ) {
            arr.push(keyTree(ele));
          }
        } else {
          if (ele != "id") {
            arr.push(keyTree(ele));
          }
        }
      });
    }
    // 数据兼容
    //兼容control
    if (
      strArr &&
      strArr.length > 0 &&
      strArr.indexOf("control") !== -1 &&
      !this.ifErji &&
      !this.addData.control
    ) {
      if (this.addData.options && this.addData.options.length > 0) {
        this.addData.control = {
          all: [],
          list: [],
          hide: false,
        };
        this.addData.options.forEach((ele: any) => {
          this.addData.control.list.push([]);
        });
      }
    }
    this.typekeys = arr;
  }
  private buchongChange(item: any) {
    if (item.type == "其它") {
      item.content_type = "text";
    }
    this.$forceUpdate();
  }
  private addJianyan() {
    this.jianyanData = {
      name: "",
      type: "",
      value: "",
    };
    this.jianyanIndex = -1;
    this.ifShowJianyanxiang = true;
  }
  private addTable() {
    this.tableData = [];
    this.ifShowTable = true;
  }
  private editTable() {
    this.tableData = JSON.parse(JSON.stringify(this.addData.value));
    this.ifShowTable = true;
  }
  private updataJianyan(e: any) {
    this.addData.children = e;
  }
  private editJianyan(e: any) {
    this.jianyanIndex = e.index;
    this.jianyanData = e.data;
    this.ifShowJianyanxiang = true;
  }
  private updateErjiData(e: any) {
    this.addData[this.erjiType] = JSON.parse(JSON.stringify(e));
    this.ifShowErji = false;
  }
  private cancel() {
    this.$emit("cancel");
  }
  private changeMark(e: any) {
    this.addData.setting.marks = e;
    this.ifShowMark = false;
  }
  private changeJianyanxiang(e: any) {
    let d = JSON.parse(JSON.stringify(this.addData.children));
    if (e.index == -1) {
      // 添加
      d.push(e.data);
    } else {
      // 编辑
      d[e.index] = e.data;
    }
    this.addData.children = d;
    this.ifShowJianyanxiang = false;
  }
  private changeTable(e: any) {
    this.addData.value = JSON.parse(JSON.stringify(e));
    this.tableData = JSON.parse(JSON.stringify(e));
    this.$forceUpdate();
    this.ifShowTable = false;
  }
  private addSure() {
    if (!this.addData.type) {
      this.$message.warning("请选择类型");
      return;
    }
    if (this.addData.options && this.addData.options.length == 0) {
      this.$message.warning("请添加选项");
      return;
    }
    if (
      (this.addData.type == "搜索多选" || this.addData.type == "目录式多选") &&
      !this.addData.search
    ) {
      this.$message.warning("请输入搜索类型");
      return;
    }
    if (this.addData.type == "图片" && !this.addData.url) {
      this.$message.warning("请输入地址");
      return;
    }
    if (this.addData.type == "图片" && !this.addData.width) {
      this.$message.warning("请输入宽度");
      return;
    }
    if (this.addData.type == "压痛点" && !this.addData.setting) {
      this.$message.warning("请选择压痛点类型");
      return;
    }
    // 自动生成id
    if (!this.addData.id) {
      this.addData.id = new Date().getTime();
      this.addData = setDefault(this.addData, true);
      this.moban.push(this.addData);
    } else {
      this.moban.forEach((ele: any, i: any) => {
        if (ele.id == this.addData.id) {
          this.addData = setDefault(this.addData, true);
          this.$set(this.moban, i, this.addData);
        }
      });
    }
    this.$emit("update", this.moban);
  }
  private getMarkData() {
    let arr: any = [];
    for (const key in this.addData.setting.marks) {
      if (
        Object.prototype.hasOwnProperty.call(this.addData.setting.marks, key)
      ) {
        const element = this.addData.setting.marks[key];
        const obj = {
          name: Number(key),
          value: element,
        };
        arr.push(obj);
      }
    }
    return arr;
  }
  private controChange() {
    let arr: any = [];
    this.addData.control.list.forEach((element: any) => {
      if (element.length > 0) {
        element.forEach((ele: any) => {
          const i = arr.indexOf(ele);
          if (i == -1) {
            arr.push(ele);
          }
        });
      }
    });
    this.addData.control.all = arr;
    this.$forceUpdate();
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  private getTitle() {
    let text: any = "";
    if (this.erjiType == "sub_title") {
      text = "补充标题";
    } else if (this.erjiType == "extra") {
      text = "二级内容";
    }
    return text;
  }
  private updata(e: any, key: any) {
    this.addData[key] = e;
  }
  private updataOption(e: any, item: any) {
    item["extra"] = e;
    this.$forceUpdate();
  }
  private editWenti(items: any, key: any) {
    this.erjiType = key;
    this.erjiData = JSON.parse(JSON.stringify(items));
    this.ifShowErji = true;
  }
  private delWenti(index: any, key: any) {
    this.addData[key].splice(index, 1);
  }
  private addOne(type: any) {
    this.erjiType = type;
    this.erjiData = {
      type: "主标题",
    };
    this.ifShowErji = true;
  }
  private ifExitKey(type: any, key: any) {
    return ifExitKey(type, key);
  }
  private addOption() {
    if (!this.optionData.name) {
      this.$message.warning("请输入选项名称");
      return;
    }
    if (
      (this.addData.type == "计分单选" ||
        this.addData.type == "sf36计分单选") &&
      !this.optionData.score &&
      this.optionData.score !== 0
    ) {
      this.$message.warning("请输入分数");
      return;
    }
    if (
      this.addData.type == "计分单选" ||
      this.addData.type == "sf36计分单选" ||
      this.addData.type == "单选补充文字" ||
      this.addData.type == "多选补充文字"
    ) {
      this.addObjOption();
    } else {
      this.addStrOption();
    }
  }
  private addObjOption() {
    let hasExit: any = false;
    this.addData.options.forEach((ele: any) => {
      if (ele.name === this.optionData.name) {
        hasExit = true;
      }
    });
    if (hasExit) {
      this.$message.warning("当前选项已存在");
      return;
    }
    let obj: any = {};
    if (
      this.addData.type == "计分单选" ||
      this.addData.type == "sf36计分单选"
    ) {
      obj = {
        name: this.optionData.name,
        score: this.optionData.score,
      };
    } else if (
      this.addData.type == "单选补充文字" ||
      this.addData.type == "多选补充文字"
    ) {
      obj = {
        id: this.optionData.name,
        name: this.optionData.name,
        type: this.optionData.type == "其它" ? "其它" : "一般",
        value: false,
        extra: [],
      };
    }
    this.addData.options.push(obj);
    this.optionData.name = "";
    this.optionData.score = null;
    this.optionData.type = "";
    // 如果content字段存在，
    // 控制逻辑里面需要添加一个对应的控制
    const keyArr: any = typeKey(this.addData.type);
    if (keyArr && keyArr.length > 0 && keyArr.indexOf("control") !== -1) {
      this.addData.control.list.push([]);
    }
  }
  private addStrOption() {
    if (this.addData.options.indexOf(this.optionData.name) != "-1") {
      this.$message.warning("当前选项已存在");
      return;
    }
    this.addData.options.push(this.optionData.name);
    this.optionData.name = "";
    // 控制逻辑里面需要添加一个对应的控制
    const keyArr: any = typeKey(this.addData.type);
    if (keyArr && keyArr.length > 0 && keyArr.indexOf("control") !== -1) {
      this.addData.control.list.push([]);
    }
  }
  private delOption(i: any) {
    this.addData.options.splice(i, 1);
    this.$forceUpdate();
    // 控制逻辑里面需要添加一个对应的控制
    const keyArr: any = typeKey(this.optionData.type);
    if (keyArr && keyArr.length > 0 && keyArr.indexOf("control") !== -1) {
      this.addData.control.list.splice(i, 1);
      this.countControlList();
    }
  }
  private addControId(index: any) {
    this.addData.control.list[index].push("");
    this.countControlList();
  }
  private countControlList() {
    let arr: any = [];
    this.addData.control.list.forEach((element: any) => {
      if (element.length > 0) {
        element.forEach((ele: any) => {
          if (arr.length === 0 || arr.indexOf("ele") == -1) {
            arr.push(ele);
          }
        });
      }
    });
    this.addData.control.all = arr;
  }
  private typeChange(e: any) {
    const id = this.addData.id;
    this.addData = {
      type: e,
      id: id,
    };
    this.addData = setDefault(this.addData);
    this.getTypeKeys();
  }
}
